import { maskEmail } from "../lib/utils";

export interface EmailNoticeProps {
  email: string;
  helper?: string;
}

export function EmailNotice({
  email,
  helper = "코드는 5분간 유효합니다. 스팸함도 확인하세요.",
}: EmailNoticeProps) {
  return (
    <div className="flex items-start gap-2.5 p-3.5 rounded-base bg-primary-soft border border-primary-border mb-5">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="text-primary flex-shrink-0 mt-px"
      >
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 7-8.97 5.7a1.94 1.94 0 01-2.06 0L2 7" />
      </svg>
      <div className="flex-1">
        <p className="text-xs font-semibold text-primary-hover">
          인증코드가 발송되었습니다
        </p>
        <span className="block text-[11px] text-primary mt-0.5">
          {maskEmail(email)} 으로 발송됨
        </span>
        <span className="block text-[11px] text-ink-subtle mt-1">{helper}</span>
      </div>
    </div>
  );
}
